export class SearchParam {
  constructor(_keyColumn?: string, _keyOperator?: string, _keyValues?: string[], _keyType? : string) {
      this.keyColumn = _keyColumn;
      this.keyOperator = _keyOperator;
      this.keyValues = _keyValues;
      this.keyType = _keyType;
  }

  public keyColumn: string | null;
  public keyOperator: string | null;
  public keyValues: string[] | null;
  public keyType : string | null;
}
